const authorisationQueryKeys = {
  allByParams: (params: { transitOperationId: number | null }) => ['v2/authorisation', params],
}

export default authorisationQueryKeys
